module.exports = __webpack_public_path__ + "img/bg_main_sec02_m.a85c0a7d.jpg";